import { apiRequest } from '@/api/http';
import { MyCapabilities } from '@/api/schemas/me';

/**
 * The caller's own effective permissions.
 *
 * `admin/me`, never `admin/staff/:userId/...`: the staff controller is entirely
 * ADMIN-only, so a STAFF member could not ask about themselves through it, and
 * it answered `[]` for an ADMIN with no profile — the normal state right after
 * a deploy. This route takes no id at all; the subject is always the bearer.
 */
export function getMyCapabilities(): Promise<MyCapabilities> {
  return apiRequest('/admin/me/capabilities', { schema: MyCapabilities });
}
